import React, { useMemo, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';

const useCreateComplexField = (nameStr, defValues) => {
  const memoizedDefValues = useMemo(
    () => defValues,
    [JSON.stringify(defValues)]
  );
  const [defaultValues, setDefaulValues] = useState(null);
  //name str is returned object's name
  //defValue are data fetched from server
  React.useEffect(() => {
    let defaultValueObj = {};

    defaultValueObj[nameStr] = defValues;
    setDefaulValues(defaultValueObj);
  }, [nameStr, memoizedDefValues]);

  const {
    control,
    formState,
    handleSubmit,
    reset,
    getValues,
    watch,
    setValue,
  } = useForm({
    defaultValues,
  });
  const { fields } = useFieldArray({
    control,
    name: nameStr,
  });

  React.useEffect(() => {
    if (memoizedDefValues) {
      if (memoizedDefValues.length > 0) {
        let updatedDefaultValueObj = {};
        updatedDefaultValueObj[nameStr] = defValues;
        reset(updatedDefaultValueObj);
      }
    }
  }, [memoizedDefValues]);

  return {
    fields,
    control,
    formState,
    getValues,
    reset,
    handleSubmit,
    watch,
    setValue,
  };
};

export default useCreateComplexField;
